// extracted by mini-css-extract-plugin
export default {"root":"HeaderSection_root__06wkV","title":"HeaderSection_title__8C8c3"};